module.exports = __webpack_public_path__ + "img/part2bg.553834f3.jpg";